import {FC} from 'react'
import {RegisterButton} from 'features/buttons'
import {text} from 'shared/mirrors/text'
import styles from './styles.module.scss'

export const CTASection: FC = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles.title}>It's time to find your match!</h2>
        <p className={styles.description}>
          {text.main.siteName} its not just a place to have chat. Its a place which brings you to
          another level of emotions. Here you can find a soulmate, discover yourself and definitely explore people with
          same values.
        </p>
        <RegisterButton className={styles.btn} styleType='primary'>Join emotions</RegisterButton>
      </div>
    </div>
  )
}